import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

const initialState = {
  pageLoading: false,
  showLearningCenterTooltip: false
};

let store = set => ({
  ...initialState,
  setPageLoading: pageLoading => {
    set(() => ({
      pageLoading
    }));
  },
  setShowLearningCenterTooltip: showLearningCenterTooltip => {
    set(() => ({
      showLearningCenterTooltip
    }));
  },
  reset: () => set(initialState)
});

store = persist(store, {
  name: 'general',
  storage: createJSONStorage(() => sessionStorage)
});
export const useGeneralStore = create(devtools(store));
